/* Lykos: sticky add-to-bag bar on phones. Built from the product form already on the page. */
(() => {
  const form = document.getElementById('product-form');
  const add = document.getElementById('pv-add');
  if (!form || !add || !('IntersectionObserver' in window)) return;

  const title = (document.querySelector('.pv-title') || {}).textContent || '';
  const colourEl = document.querySelector('.opt-label .dim');
  const colour = colourEl ? colourEl.textContent.trim() : '';
  const price = add.dataset.price || ((document.querySelector('.pv-price') || {}).textContent || '').trim();
  const sizes = document.getElementById('pv-sizes');
  const msg = document.getElementById('pv-msg');

  const bar = document.createElement('div');
  bar.className = 'buybar';
  bar.id = 'buybar';
  bar.setAttribute('aria-hidden', 'true');
  bar.inert = true;
  const txt = document.createElement('div');
  txt.className = 'buybar-txt';
  const b = document.createElement('b');
  b.textContent = title.trim() + (colour ? ' · ' + colour : '');
  const s = document.createElement('span');
  s.textContent = price;
  txt.append(b, s);
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn btn-solid';
  txt.id = 'buybar-txt';
  bar.append(txt, btn);
  document.body.appendChild(bar);

  const chosen = () => form.querySelector('input[name="id"]:checked');
  const needsSize = () => !!form.querySelector('input[type="radio"][name="id"]');
  const label = () => {
    if (add.disabled && !chosen()) { btn.textContent = add.textContent.trim() || 'Sold out'; btn.disabled = /sold out/i.test(btn.textContent); return; }
    btn.disabled = false;
    btn.textContent = !needsSize() || chosen() ? 'Add to bag' : 'Choose size';
  };
  label();
  form.addEventListener('change', label);

  btn.addEventListener('click', () => {
    if (needsSize() && !chosen()) {
      (sizes || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (sizes) { sizes.classList.remove('nudge'); void sizes.offsetWidth; sizes.classList.add('nudge'); }
      if (msg) msg.textContent = 'Choose a size first.';
      return;
    }
    if (typeof form.requestSubmit === 'function') form.requestSubmit(add); else add.click();
  });

  /* show the bar only while the main button is off screen */
  const io = new IntersectionObserver(([e]) => {
    const show = !e.isIntersecting;
    bar.classList.toggle('on', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
  }, { threshold: 0 });
  io.observe(add);
})();
